import React from "react"

type Props = {
  className?: string
}

const SalesIcon = ({ className }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5058 2.72555L11.7142 2.13472C12.2717 1.86222 12.9458 2.08055 13.2367 2.62972L13.8675 3.81805C14.0342 4.13139 14.3358 4.35055 14.6858 4.41222L16.0108 4.64472C16.6225 4.75222 17.0383 5.32472 16.9517 5.93972L16.7633 7.27139C16.7133 7.62305 16.8292 7.97805 17.0758 8.23305L18.0108 9.19972C18.4425 9.64555 18.4425 10.3539 18.0108 10.8006L17.0758 11.7672C16.8292 12.0222 16.7133 12.3772 16.7633 12.7289L16.9517 14.0606C17.0383 14.6756 16.6225 15.2481 16.0108 15.3556L14.6858 15.5881C14.3358 15.6497 14.0342 15.8689 13.8675 16.1822L13.2367 17.3706C12.9458 17.9189 12.2725 18.1381 11.7142 17.8656L10.5058 17.2747C10.1867 17.1189 9.81418 17.1189 9.49501 17.2747L8.28668 17.8656C7.72918 18.1381 7.05501 17.9197 6.76418 17.3706L6.13334 16.1814C5.96668 15.8681 5.66501 15.6489 5.31501 15.5872L3.99001 15.3547C3.37834 15.2472 2.96251 14.6747 3.04918 14.0597L3.23751 12.7281C3.28751 12.3764 3.17168 12.0214 2.92501 11.7664L1.99001 10.7997C1.55834 10.3539 1.55834 9.64555 1.99001 9.19889L2.92501 8.23222C3.17168 7.97722 3.28751 7.62222 3.23751 7.27055L3.05001 5.93889C2.96251 5.32472 3.37918 4.75139 3.99084 4.64472L5.31584 4.41222C5.66501 4.35055 5.96668 4.13139 6.13334 3.81805L6.76418 2.62972C7.05501 2.08139 7.72834 1.86222 8.28668 2.13472L9.49501 2.72555C9.81334 2.88139 10.1867 2.88139 10.5058 2.72555Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.77319 12.2263L12.225 7.77441"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4261 12.07C12.5215 12.1685 12.5198 12.3254 12.4223 12.4218C12.3249 12.5182 12.168 12.5182 12.0705 12.4218C11.9731 12.3254 11.9714 12.1685 12.0668 12.07C12.1139 12.0213 12.1787 11.9939 12.2464 11.9939C12.3142 11.9939 12.379 12.0213 12.4261 12.07"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.93244 7.57097C8.02781 7.66944 8.02613 7.82634 7.92868 7.92276C7.83123 8.01917 7.67432 8.01917 7.57687 7.92276C7.47942 7.82634 7.47775 7.66944 7.57312 7.57097C7.62023 7.52232 7.68506 7.49486 7.75278 7.49486C7.8205 7.49486 7.88532 7.52232 7.93244 7.57097"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SalesIcon
